import { getPagePath, trans } from '@spotahome/soyuz/client';

import { Link } from '@spotahome/ui-library';
import FAQAccordion from '@spotahome/ui-library/src/tenant/components/FAQSection/FAQAccordion';

import { getFaqs } from '../utils/faqs';

import Section from './Section';

import './Faqs.scss';

const Faqs = () => {
  return (
    <div className="hiw-faqs__wrapper">
      <Section className="hiw-faqs">
        <div className="hiw-faqs__title-container">
          <h2 className="hiw-faqs__title">
            {trans('how-it-works.faqs.title')}
          </h2>
          <p className="hiw-faqs__subtitle">
            {trans('how-it-works.faqs.subtitle')}
          </p>
          <Link href={getPagePath('externals.help-center')} bold>
            {trans('how-it-works.faqs.help-link')}
          </Link>
        </div>
        <FAQAccordion
          data={getFaqs()}
          theme="how-it-works"
          className="hiw-faqs__faqs-accordion"
        />
      </Section>
    </div>
  );
};

export default Faqs;
